import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Package, Cpu, Rocket, Trash2, ChevronLeft } from "lucide-react";
import AdminStatCard from "../SuperUserDashboard/AdminStatCard";

const ManufacturingHero = ({ stats }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="px-6 pb-6 pt-5">
      <button
        onClick={() => navigate("/v2/admin/default")}
        className="mb-3 flex items-center gap-1 text-xs font-medium text-[#6B7280] transition-colors duration-150 hover:text-[#E07A3A]"
      >
        <ChevronLeft size={14} />
        {t("admin.manufacturing.hero.backToAdmin")}
      </button>

      <div className="mb-5">
        <h1 className="text-xl font-bold text-[#111827]">
          {t("admin.manufacturing.hero.title")}
        </h1>
        <p className="mt-0.5 text-xs text-[#6B7280]">
          {t("admin.manufacturing.hero.subtitle")}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <AdminStatCard
          icon={Package}
          label={t("admin.manufacturing.hero.totalBatches")}
          value={stats.totalBatches}
        />
        <AdminStatCard
          icon={Cpu}
          label={t("admin.manufacturing.hero.totalWearables")}
          value={stats.totalWearables}
        />
        <AdminStatCard
          icon={Rocket}
          label={t("admin.manufacturing.hero.deployed")}
          value={stats.deployed}
        />
        <AdminStatCard
          icon={Trash2}
          label={t("admin.manufacturing.hero.scrapped")}
          value={stats.scrapped}
        />
      </div>
    </div>
  );
};

export default ManufacturingHero;
